import React, { ReactElement } from 'react';
import {
  useDimensions,
  useMaskContext,
} from '@/features/remotion-editor/editor/utils/use-context';

type MaskWrapperProps = {
  children: ReactElement;
  shouldApply: boolean;
};

export const MaskWrapper = ({ children, shouldApply }: MaskWrapperProps) => {
  const { mask } = useMaskContext();
  const { compositionWidth, compositionHeight } = useDimensions();

  if (!mask || !mask.enabled || !shouldApply) {
    return children;
  }

  return (
    <div
      style={{
        position: 'absolute',
        left: 0,
        top: 0,
        width: compositionWidth,
        height: compositionHeight,
        pointerEvents: 'none',
      }}
    >
      <div
        style={{
          position: 'absolute',
          left: mask.x,
          top: mask.y,
          width: mask.width,
          height: mask.height,
          overflow: 'hidden',
          pointerEvents: 'auto',
        }}
      >
        <div
          style={{
            position: 'absolute',
            left: -mask.x,
            top: -mask.y,
            width: compositionWidth,
            height: compositionHeight,
          }}
        >
          {children}
        </div>
      </div>
    </div>
  );
};
